import { createReducerFromMap } from "@coverme/redux";

const initialState = {
    establishedTrustInPastFiveYears: null,
    referralDetails: {
        currentResidenceType: "",
        referralSource: undefined,
        currentResidenceTypeDescription: "",
        referralSourceDescription: "",
        referralFacilityName: "",
        expectedDischargeDate: undefined,
        isContactAvailableToAssist: undefined,
        referralContactDetails: {
            firstName: "",
            lastName: "",
            phoneNumber: "",
            phoneType: "",
            additionalContactNumberDetails: [],
            contactZipCode: "",
        },
    },
    additionalContactDetails: {
        firstName: "",
        lastName: "",
        phoneNumber: "",
        phoneType: "",
        additionalContactNumberDetails: [],
        relationToPatient: "",
        address: {},
        organizationName: "",
        organizationIdNumber: "",
    },
};

function updateLongTermCareDetails(state, data) {
    return {
        ...state,
        ...data.value,
    };
}

function resetInterview(state, action) {
    return initialState;
}

function getInterview(state, action) {
    if (action.value.longTermCare) {
        return updateLongTermCareDetails(state, { value: action.value.longTermCare });
    }

    return state;
}

export const longTermCareReducer = createReducerFromMap(initialState, {
    CREATE_LONG_TERM_CARE_DETAILS_COMPLETE: updateLongTermCareDetails,
    RESET_INTERVIEW: resetInterview,
    GET_INTERVIEW_COMPLETE: getInterview,
});
